import { createUserWithEmailAndPassword } from "firebase/auth";
import { auth } from "~/lib";
import { SignUpFormValues } from "~/types";

/**
 * Creates a Firebase Auth user (email/password sign-up).
 * DynamoDB + Firestore profile are ensured by Lambda sign-in after auth.
 */
export const addFirebaseUser = async (
  payload: SignUpFormValues,
  createUser: boolean
) => {
  if (!createUser) {
    return {
      success: false,
      error: "Auth user creation is required",
    };
  }

  try {
    const user = await createUserWithEmailAndPassword(
      auth,
      payload.email,
      payload.password
    );

    return {
      success: true,
      data: { id: user.user.uid },
    };
  } catch (error: unknown) {
    const message =
      error instanceof Error ? error.message : "Sign up failed";
    console.error("Error adding user to Firebase Auth", error);
    return {
      success: false,
      data: {},
      error: message,
    };
  }
};
